import styled from '@emotion/styled';
import { mainColors } from 'src/assets/colors';

export const ComplianceConfigurationLicenseConfigWrapper = styled('div', { label: 'ComplianceConfigurationLicenseConfigWrapper' })`
    display: flex;
    flex-direction: column;
    gap: 24px;
    font-family: var(--font-family-primary);
`;

export const ComplianceConfigurationLicenseConfigDescription = styled('p', { label: 'ComplianceConfigurationLicenseConfigDescription' })`
    margin: 0;
    font-size: 14px;
    line-height: 1.43;
    color: ${mainColors.grays.gray500};
`;

export const ComplianceConfigurationLicenseConfigSection = styled('section', { label: 'ComplianceConfigurationLicenseConfigSection' })`
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding: 20px;
    border: 1px solid ${mainColors.grays.gray200};
    border-radius: 8px;
    background-color: ${mainColors.default.light};
`;

export const ComplianceConfigurationLicenseConfigSectionTitle = styled('h3', { label: 'ComplianceConfigurationLicenseConfigSectionTitle' })`
    margin: 0;
    font-size: 14px;
    font-weight: 600;
    line-height: 1.43;
    color: ${mainColors.main.primary};
`;

export const ComplianceConfigurationLicenseConfigCurrencyField = styled('div', { label: 'ComplianceConfigurationLicenseConfigCurrencyField' })`
    display: flex;
    flex-direction: column;
    gap: 8px;
    max-width: 320px;

    > div {
        margin-bottom: 0;
    }
`;

export const ComplianceConfigurationLicenseConfigCurrencyFieldLabel = styled('span', { label: 'ComplianceConfigurationLicenseConfigCurrencyFieldLabel' })`
    font-size: 12px;
    font-weight: 500;
    line-height: 1.33;
    color: ${mainColors.grays.gray400};
`;

export const ComplianceConfigurationLicenseConfigFormFields = styled('div', { label: 'ComplianceConfigurationLicenseConfigFormFields' })`
    display: flex;
    flex-direction: column;
    gap: 12px;
`;

export const ComplianceConfigurationLicenseConfigFormRow = styled('div', { label: 'ComplianceConfigurationLicenseConfigFormRow' })`
    display: flex;
    flex-direction: column;
    gap: 8px;

    @media (min-width: 768px) {
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        gap: 16px;
    }
`;

export const ComplianceConfigurationLicenseConfigFormLabel = styled('label', { label: 'ComplianceConfigurationLicenseConfigFormLabel' })`
    font-size: 14px;
    font-weight: 500;
    line-height: 1.43;
    color: ${mainColors.main.primary};
    flex: 1;
`;

export const ComplianceConfigurationLicenseConfigFormValue = styled('div', { label: 'ComplianceConfigurationLicenseConfigFormValue' })`
    display: flex;
    align-items: center;
    gap: 8px;
    width: 100%;
    max-width: 280px;
`;

export const ComplianceConfigurationLicenseConfigCurrencyPrefix = styled('span', { label: 'ComplianceConfigurationLicenseConfigCurrencyPrefix' })`
    font-size: 14px;
    font-weight: 500;
    line-height: 1.43;
    color: ${mainColors.grays.gray500};
    flex-shrink: 0;
`;

export const ComplianceConfigurationLicenseConfigActions = styled('div', { label: 'ComplianceConfigurationLicenseConfigActions' })`
    display: flex;
    justify-content: flex-start;
    margin-top: 24px;
`;
